/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relativeminagoone3Inputs */

const en_relativeminagoone3 = /** @type {(inputs: Relativeminagoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 min ago`)
};

const pt_relativeminagoone3 = /** @type {(inputs: Relativeminagoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`há 1 min`)
};

/**
* | output |
* | --- |
* | "1 min ago" |
*
* @param {Relativeminagoone3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativeminagoone3 = /** @type {((inputs?: Relativeminagoone3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativeminagoone3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativeminagoone3(inputs)
	return pt_relativeminagoone3(inputs)
});
export { relativeminagoone3 as "relativeMinAgoOne" }